class ContratoController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'contratoService' ]

  constructor: ($injector, pathService, @contratoService) ->
    super($injector)

    @listOfContrato = []
    @loadingTracker = @promiseTracker()

    @empresaModal = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/dashboard/cadastro-empresa/modal.html', 'empresaController as ctrl', 'lg', 'static')
    @modalAddEmpresa = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/wizard/modal.html', 'empresaWizardController as ctrl', 'lg', 'static')
    @modalCertificado = @openPopup(pathService.getViewUrl() + 'certificado.html', 'contratoCertificadoModalController as ctrl', 'md', 'static')

    @loadDefault()

  loadDefault: ->
    @loadingTracker.addPromise @contratoService.search({select_type: 'complete', buscar_todos: true}, (data) =>
      @listOfContrato = data
    )

  adicionar: ->
    @modalAddEmpresa({}, (result) => @loadDefault() if result.success )

  openEmpresaModal: (contrato) ->
    @empresaModal({
      contrato: => contrato.id
    })

  certificado: (contrato) ->
    @modalCertificado({
      contrato: -> contrato
    }, (result) => @loadDefault())

  alterarStatusEmpresa: (contrato) ->
    texto = "Deseja realmente #{ if contrato.status then 'desativar' else 'ativar'} a empresa ##{contrato.id} | #{contrato.razaoSocial}?";
    @Confirm.warning("Atenção", texto, {
      "Sim": =>
        @contratoService.alterarStatus({contrato: contrato.id}, (result) =>
          if(result.success)
            @Alert.success("Status da empresa ##{ contrato.id } - #{contrato.razaoSocial} alterado com sucesso!")
            @loadDefault()
        )
      "Não": ->
    })

angular.module("eficienciaFiscalModule").controller('contratoController', ContratoController)